import React from "react";
import { Box, Container } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import HeroCst from "@components/HeroCst";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "@components/Breadcrumb";
import { useTranslation } from "react-i18next";
import CoursesFormCst from "@pages/Contents/Corporate/Catalog/Courses/CoursesFormCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import AnimationFadeIn from "@components/AnimationFadeIn";
import { PagesID } from "@utils/utilsConfigurations";
import { useAddCourses } from "@hooks/hookscatalog/Courses/useAddCourses";

const AddCoursesDigited: React.FC = () => {
  const { t } = useTranslation(["courses-digited-page"]);
  const navigate = useNavigate();

  const { onSubmit, openToast, setOpenToast, columns, actionsForForms } =
    useAddCourses(PagesID["catalog.courses"], "1");

  return (
    <AnimationFadeIn>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-courses.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("add.hero-title")}
          description={t("add.hero-description")}
        />
        {columns && (
          <Box
            sx={{
              mt: "25px",
            }}
          >
            <CoursesFormCst
              row={{ specializations: "NONE" }}
              columns={columns}
              onSubmit={onSubmit}
              backButton={() => {
                navigate(`/catalog/courses`);
              }}
              actionsForForms={actionsForForms}
              isCreate={true}
            />
          </Box>
        )}
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("hero-title-add")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </AnimationFadeIn>
  );
};

export default AddCoursesDigited;
